import { useContext } from 'react'
import { NotificationContext } from '../contexts/notification-context'

export const useNotification = () => useContext(NotificationContext)
